import { action, computed, observable } from 'mobx';
import { BreadcrumbData } from 'components/Breadcrumbs/Breadcrumbs';
import { RootStore } from './rootStore';
import * as routes from 'routes';

export class BreadcrumbsStore {
  private rootStore: RootStore;

  @observable
  privateBreadcrumbs: BreadcrumbData[] = [];
  @observable home: string = routes.HOME_PAGE;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @computed
  get breadcrumbs(): BreadcrumbData[] {
    return this.privateBreadcrumbs;
  }

  @action
  setHome = (home?: string) => {
    this.home = home ? home : routes.HOME_PAGE;
  };

  @action
  addBreadcrumb = (data: BreadcrumbData) => {
    this.privateBreadcrumbs.push(data);
  };

  @action
  updateByTitle = (oldTitle: string, newTitle: string) => {
    this.privateBreadcrumbs = this.privateBreadcrumbs.map((breadcrumb) => {
      if (breadcrumb.title === oldTitle) {
        return { ...breadcrumb, title: newTitle, renamed: true };
      }
      return breadcrumb;
    });
  };

  @action
  removeBreadcrumbs = () => {
    this.privateBreadcrumbs = [];
  };

}
